<app-section #parentSection
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             [sectionRef]="section"
             [title]="title"
             class="discount-codes-section"
             *ngIf="sectionVisible"
             [containerClass]="true">

  <ng-template #section>

    <div class="col">
    <ng-container *ngFor="let icCode of insuranceCompaniesWithDiscountCodes">
        <div class="section__component col-33">
          <ng-container *ngIf="icCode === 'TUZ' || icCode === 'EUROINS'; else textField">
            <app-select
                    [errorsMap]="formFactoryService.errorsMap"
                    [control]="formGroup.controls[icCode]"
                    [bean]="bean"
                    [fieldConfig]="formFactoryService.fieldConfig(icCode, formConfig)"
                    [context]="formConfig.formKey"
            >
            </app-select>
          </ng-container>
          <ng-template #textField>
            <app-text-field
                    [errorsMap]="formFactoryService.errorsMap"
                    [bean]="bean"
                    [control]="formGroup.controls[icCode]"
                    [fieldConfig]="formFactoryService.fieldConfig(icCode, formConfig)"
                    [context]="formConfig.formKey"
            >
            </app-text-field>
          </ng-template>
        </div>
    </ng-container>
    </div>

  </ng-template>
</app-section>
